
async function devtricker_get_sortedFollowingUserHash(userId) {

    const url = `/wp-admin/admin-ajax.php?action=devtricker_follow_action_get_sorted_following_hash_ajax&user_id=${userId}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
        });

        if (!response.ok) {
            throw new Error('Error when try get follow user checksum');
        }

        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            throw new Error(result.data);
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_post_ajaxFollowUser(userToFollowId, followAction) {
    await devtricker_validateUserToFollowId(userToFollowId);
    await devtricker_validateFollowAction(followAction);

    let formData = new FormData();
    formData.append('action', 'devtricker_follow_action_toggle_follow_ajax');
    formData.append('user_id_to_follow', userToFollowId);
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('is_to_follow', followAction);

    let blobData = new Blob([new URLSearchParams(formData).toString()], {
        type: 'application/x-www-form-urlencoded'
    });

    const success = navigator.sendBeacon('/wp-admin/admin-ajax.php', blobData);

    if (!success) {
        console.error("It was not possible to enqueue the data to be sent by the browser.");
    }
}

async function devtricker_ajax_getUserFollowing(userId, page, nonce) {
    try {
        const url = `/wp-admin/admin-ajax.php?action=devtricker_follow_action_get_following_ajax&user_id=${userId}&page=${page}&nonce=${nonce}`;
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, `User following successfully retrieved - AJAX - Page: ${page}`);
            return {
                following: result.data.following,
                hasNext: response.headers.get('X-Has-Next') === 'true'
            };
        } else {
            throw new Error(result.data.message);
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_post_syncfollowdata(userId) {
    try {

        const form = new FormData();

        form.append('action', 'devtricker_sync_following_list');

        const followingIds = devtricker_session_getAllFollowingIds();
        followingIds.forEach(id => form.append('submitted_ids[]', id));

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        const result = await response.json();

        if (result.success) {
            return {
                to_follow: result.data.to_follow,
                to_unfollow: result.data.to_unfollow,
                message: "Sync operation successful."
            };
        } else {
            throw new Error(result.data.message);
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_checkIfFollowing(userIds) {
    try {
        const params = new URLSearchParams();
        params.append('action', 'devtricker_follow_action_check_multiple_ajax');
        userIds.forEach(id => params.append('user_ids[]', id.toString()));

        const url = `/wp-admin/admin-ajax.php?${params.toString()}`;

        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, 'Follow status successfully retrieved - AJAX');
            return result.data; // Ex: { "1": true, "2": false }
        } else {
            throw new Error(result.data?.message || 'Unknown error while checking follow status.');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}